export const getReportBoard = {
  success: true,
  groupID: 7,
  boardInfo: {
    ID: 13,
    title: "testEV2",
    url: "testEV2",
  },
  columns: [
    {
      Header: "",
      accessor: "name",
    },
    {
      ID: 39,
      accessor: "data_39",
      Header: "Checklist Column",
      typeDictID: 1,
      sheetID: 13,
      orderBy: 1,
      isShared: false,
      canEdit: true,
      canEditHeader: true,
      canFilter: true,
      canDelete: true,
    },
    {
      ID: 40,
      accessor: "data_40",
      Header: "Text Column",
      typeDictID: 2,
      sheetID: 13,
      orderBy: 2,
      isShared: false,
      canEdit: true,
      canEditHeader: true,
      canFilter: true,
      canDelete: true,
    },
    {
      ID: 41,
      accessor: "data_41",
      Header: "Number Column",
      typeDictID: 3,
      sheetID: 13,
      orderBy: 3,
      isShared: false,
      canEdit: true,
      canEditHeader: true,
      canFilter: true,
      canDelete: true,
    },
  ],
  savedBoardFilter: {
    savedFilterRequestID: 7,
    title: "Saved Filter",
    includeInactive: 0,
    isShared: 1,
    created: 123456,
    filters: {
      and: [
        {
          or: [
            {
              and: [
                {
                  filterID: 5,
                  isNegated: false,
                  inputs: {
                    searchTerm: "User",
                  },
                },
                {
                  filterID: 6,
                  isNegated: false,
                  inputs: [],
                },
              ],
            },
          ],
        },
      ],
    },
  },
  filteredTotal: 10,
  unfilteredTotal: 24,
  rows: [
    {
      entityID: 7,
      entityType: "user",
      originalIndex: 0,
      name: "User 0",
    },
    {
      entityID: 8,
      entityType: "user",
      originalIndex: 0,
      name: "User 1",
    },
    {
      entityID: 9,
      entityType: "user",
      originalIndex: 0,
      name: "User 2",
    },
    {
      entityID: 10,
      entityType: "user",
      originalIndex: 0,
      name: "User 3",
    },
    {
      entityID: 11,
      entityType: "user",
      originalIndex: 0,
      name: "User 4",
    },
    {
      entityID: 12,
      entityType: "user",
      originalIndex: 0,
      name: "User 5",
    },
    {
      entityID: 13,
      entityType: "user",
      originalIndex: 0,
      name: "User 6",
    },
    {
      entityID: 14,
      entityType: "user",
      originalIndex: 0,
      name: "User 7",
    },
    {
      entityID: 15,
      entityType: "user",
      originalIndex: 0,
      name: "User 8",
    },
    {
      entityID: 16,
      entityType: "user",
      originalIndex: 0,
      name: "User 9",
    },
  ],
  rowTotals: [],
  isShared: false,
  permissions: [],
  everyoneGroupID: 7,
  isApp: false,
  userID: 2,
};
